/**
 * 参考资料格式转换工具
 * 用于将搜索结果或联网内容转换为markdown格式的参考资料
 */

/**
 * 将JSON格式的参考资料转换为markdown格式
 * @param {string} jsonString - JSON格式的参考资料字符串
 * @returns {string} markdown格式的参考资料，如果解析失败返回空字符串
 */
export const formatReferencesToMarkdown = (jsonString) => {
  if (!jsonString || typeof jsonString !== 'string') {
    return '';
  }

  try {
    const references = JSON.parse(jsonString);

    if (!Array.isArray(references) || references.length === 0) {
      return '';
    }

    let markdownContent = '\n\n# 参考资料：\n';
    references.forEach((item, index) => {
      if (item.title && item.href) {
        markdownContent += `${index + 1}、[${item.title}](${item.href})\n`;
      }
    });

    return markdownContent;
  } catch (error) {
    console.log('解析参考资料失败:', error);
    return '';
  }
};

/**
 * 处理消息中的answerWeb字段，将其转换为参考资料并追加到answer后面
 * @param {object} message - 消息对象
 * @returns {object} 处理后的消息对象
 */
export const processMessageWithReferences = (message) => {
  if (!message) return message;

  // 创建消息副本以避免修改原对象
  const processedMessage = { ...message };

  // 处理answerWeb字段
  if (message.answerWeb) {
    const references = formatReferencesToMarkdown(message.answerWeb);
    if (references) {
      // 将参考资料追加到answer后面
      processedMessage.answer = (message.answer || '') + references;
    }
  }

  // 处理kbSource字段（知识库引用）- 从历史记录接口返回的数据
  if (message.kbSource) {
    // 直接保留kbSource字段，不需要特殊处理
    // MessageItem组件会负责渲染
    if (typeof message.kbSource === 'string') {
      processedMessage.kbSource = JSON.parse(message.kbSource);
    } else {
      processedMessage.kbSource = message.kbSource;
    }
  }

  processedMessage.branchMax = message.branchMax ?? 1;
  processedMessage.branchId = message.branchId ?? 1;
  processedMessage.fMessageId = message.fMessageId ?? 0;

  return processedMessage;
};

/**
 * 批量处理消息列表中的参考资料
 * @param {array} messages - 消息列表
 * @returns {array} 处理后的消息列表
 */
export const processMessagesWithReferences = (messages) => {
  if (!Array.isArray(messages)) return messages;

  return messages.map(processMessageWithReferences);
};
